import { render, staticRenderFns } from "./OrticTextarea.vue?vue&type=template&id=7f20a02d&"
import script from "./OrticTextarea.vue?vue&type=script&lang=js&"
export * from "./OrticTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports